// Components
import { Skeleton } from './Skeleton';

// Utils
import { cn } from '../../utils/cn';

// Types
type BlogCardSkeletonProps = {
  /** Additional className for custom styling */
  className?: string;
};

/**
 * Skeleton placeholder for the BlogCard component
 * Matches the vertical layout: image on top, content below
 */
export const BlogCardSkeleton = ({ className }: BlogCardSkeletonProps) => {
  return (
    <div
      className={cn(
        'flex flex-col bg-white border border-gray-200 rounded-12 overflow-hidden',
        'w-full max-w-[323px]',
        className
      )}
      aria-label="Loading article"
      role="status"
    >
      {/* Cover Image Placeholder */}
      <div className="w-full aspect-[323/243]">
        <Skeleton className="w-full h-full rounded-none" />
      </div>

      {/* Content */}
      <div className="flex flex-col gap-[var(--spacing-8)] p-[var(--spacing-24)]">
        {/* Title - Two lines */}
        <div className="flex flex-col gap-[var(--spacing-4)]">
          <Skeleton className="h-[24px] w-full" />
          <Skeleton className="h-[24px] w-[75%]" />
        </div>

        {/* Excerpt - Three lines */}
        <div className="flex flex-col gap-[var(--spacing-4)]">
          <Skeleton className="h-[16px] w-full" />
          <Skeleton className="h-[16px] w-full" />
          <Skeleton className="h-[16px] w-[60%]" />
        </div>

        {/* Author */}
        <Skeleton className="h-[20px] w-[120px] mt-[var(--spacing-4)]" />

        {/* Tags */}
        <Skeleton className="h-[14px] w-[160px]" />
      </div>
    </div>
  );
};

